module.exports = __webpack_public_path__ + "media/images/flags/64/Brunei-38cbf82e569f2eff7adb6f0441c94594.png";